import { React, useState } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import ClientComplaintForm from './ClientComplaintForm';

// Bouton "Créer une réclamation" + formulaire partagé (mode création)
const ClientComplaintCreate = (props) => {
  const { user, update, setUpdate, getTickets } = props;
  const [open, setOpen] = useState(false);

  const handleSaved = () => {
    setUpdate(!update);
    if (getTickets) getTickets();
  };

  return (
    <>
      <Button
        color="primary"
        startIcon={<AddIcon fontSize="small" />}
        variant="contained"
        onClick={() => setOpen(true)}
      >
        Créer une réclamation
      </Button>

      <ClientComplaintForm
        open={open}
        onClose={() => setOpen(false)}
        mode="create"
        user={user}
        onSaved={handleSaved}
      />
    </>
  );
};

ClientComplaintCreate.propTypes = {
  user: PropTypes.object.isRequired,
  update: PropTypes.bool.isRequired,
  setUpdate: PropTypes.func.isRequired,
  getTickets: PropTypes.func
};

export default ClientComplaintCreate;
